import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Logo from "../components/site/Logo";
import { LogIn, ShieldCheck, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, loading, checked, checkAuth } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();

  useEffect(() => { if (!checked && !loading) checkAuth(); }, [checked, loading, checkAuth]);

  useEffect(() => {
    if (params.get("error")) toast.error("Innlogging feilet. Prøv igjen.");
  }, [params]);

  useEffect(() => {
    if (!loading && user?.is_admin) navigate("/admin", { replace: true });
  }, [loading, user, navigate]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-navy flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="flex justify-center"><Logo /></div>
        <div className="mt-8 rounded-2xl bg-white p-8 shadow-xl">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-xl bg-electric/10 text-electric">
            <ShieldCheck className="h-7 w-7" />
          </span>
          <h1 className="mt-5 text-center font-heading text-2xl font-bold text-navy">Eierinnlogging</h1>
          <p className="mt-2 text-center text-sm text-ink/60">
            Logg inn for å administrere tjenester, priser, bestillinger og forespørsler.
          </p>
          <button
            onClick={login}
            className="mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-navy px-6 py-3.5 text-base font-semibold text-white hover:bg-navy-800 transition-colors"
            data-testid="google-login-button"
          >
            <LogIn className="h-5 w-5" /> Logg inn med Google
          </button>
          <a href="/" className="mt-4 flex items-center justify-center gap-1.5 text-sm text-ink/50 hover:text-electric">
            <ArrowLeft className="h-4 w-4" /> Tilbake til nettstedet
          </a>
        </div>
        <p className="mt-6 text-center text-xs text-slate-400">Kun godkjent eierkonto har tilgang.</p>
      </div>
    </div>
  );
}
